import { futureValueLimitedPeriodSIP } from "../../engine/calculations";

const fvLimitedPeriodSipConfig = {
  key: "fv-limited-period-sip",
  title: "Future Value of Limited Period SIP",
  category: "Growth",
  description: "Run a SIP for a few years, then let the corpus keep growing untouched until your target date.",
  fields: [
    { key: "monthly", label: "Monthly SIP amount", type: "currency", default: 15_000, min: 500, max: 10_00_000 },
    { key: "sipYears", label: "Years you'll invest (SIP period)", type: "number", default: 10, min: 1, max: 40 },
    { key: "totalYears", label: "Total years until you need the money", type: "number", default: 20, min: 1, max: 50, help: "Include the SIP years — the corpus keeps compounding after the SIP stops." },
    { key: "returnRate", label: "Expected annual return", type: "percent", default: 12, min: 1, max: 30, assumptionKey: "equityReturn" },
  ],
  chart: {
    type: "bar",
    xKey: "name",
    series: [{ key: "amount", label: "Amount", colorVar: "--gold" }],
  },
  compute(values) {
    const monthly = Number(values.monthly) || 0;
    const sipYears = Number(values.sipYears) || 0;
    const totalYears = Number(values.totalYears) || 0;
    const annualRate = (Number(values.returnRate) || 0) / 100;

    const activeSipYears = Math.min(sipYears, totalYears);
    const totalInvested = monthly * activeSipYears * 12;
    const futureValue = futureValueLimitedPeriodSIP(monthly, annualRate, sipYears, totalYears);

    return {
      headline: { label: "Future Value", value: futureValue },
      extraHeadlines: [
        { label: "Years you invest", value: activeSipYears, format: "text" },
        { label: "Years it then compounds untouched", value: Math.max(totalYears - activeSipYears, 0), format: "text" },
      ],
      breakdown: [
        { label: "Total Invested", value: totalInvested },
        { label: "Estimated Gains", value: futureValue - totalInvested },
      ],
      series: [
        { name: "Invested", amount: totalInvested },
        { name: "Future Value", amount: futureValue },
      ],
    };
  },
};

export default fvLimitedPeriodSipConfig;
